import { userContext } from 'contexts/UserContext';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoyaltyBalanceQuery } from 'services';

import styles from './UserLoyaltyBalance.module.scss';

interface UserLoyaltyBalanceProps {
  email?: string;
}

export function UserLoyaltyBalance({ email }: UserLoyaltyBalanceProps) {
  const { user } = useContext(userContext);
  const { data } = useLoyaltyBalanceQuery(email ?? user.Email);
  const { t } = useTranslation('loyalty');

  const message = useMemo(() => {
    if (data?.result) {
      return t('message', { amount: data?.result.amount });
    }
    return t('emptyBalance');
  }, [data?.result, t]);

  return (
    <span
      className={styles.container}
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  );
}
